<div class="featured page" *ngIf="users">
  <div class="title">Featured Anglers</div>
  <div class="description">Check out a few of our featured members!</div>
  <div class="content">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide *ngFor="let user of users">
        <div class="item" fxLayout="column" fxLayoutAlign=" center">
          <div class="item__image" (click)="navigateSignup()"><img class="image" src="{{ getProfilePhotoUrl(user) }}" /></div>
          <div class="item__name" (click)="navigateSignup()">{{ user.Name }}</div>
          <div class="item__location">
            {{ user.Location }}
          </div>
          <div class="item__button" (click)="navigateSignup()">
            <app-button>Follow</app-button>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
